const Category = [
    'Data Structures & Algorithms',
    'Web Development',
    'App Development',
    'Git & Github',
    'DevOps Bootcamp',
    'Game Development',
    'Machine Learning',
    'System Design',
    'DataBase Management System',
    'Operating System',
    'UI / UX Design',
    'Graphics Designing',
    'Cloud Computing'
]

export default Category